"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  name: 'Conrad B. Duberstein United States Bankruptcy Courthouse',
  address: {
    display: '271-C Cadman Plaza East Brooklyn, NY 11201',
    number: '271-C',
    street: 'Cadman Plaza East',
    city: 'Brooklyn',
    state: 'NY',
    zipcode: '11201'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-eastern-bankruptcy-court-brooklyn',
  phone: '347-394-1700',
  state: 'NY',
  district: 'nyeb',
  coordinates: {
    latitude: 40.696145,
    longitude: -73.99005
  }
}, {
  name: "Alfonse M. D'Amato United States Courthouse",
  address: {
    display: 'Federal Plaza Central Islip, NY 11722',
    number: null,
    street: 'Federal Plaza',
    city: 'Central Islip',
    state: 'NY',
    zipcode: '11722'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-eastern-bankruptcy-court-central-islip',
  phone: '631-712-6200',
  state: 'NY',
  district: 'nyeb',
  coordinates: {
    latitude: 40.75998,
    longitude: -73.19175
  }
}, {
  name: 'Alexander Hamilton Custom House',
  address: {
    display: 'One Bowling Green New York, NY 10004',
    number: null,
    street: 'One Bowling Green',
    city: 'New York',
    state: 'NY',
    zipcode: '10004'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-southern-bankruptcy-court-new-york',
  phone: '212-668-2870',
  state: 'NY',
  district: 'nysb',
  coordinates: {
    latitude: 40.7044501,
    longitude: -74.0142298
  }
}, {
  name: 'Charles L. Brieant, Jr. United States Courthouse',
  address: {
    display: '300 Quarropas Street White Plains, NY 10601',
    number: '300',
    street: 'Quarropas Street',
    city: 'White Plains',
    state: 'NY',
    zipcode: '10601'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-southern-bankruptcy-court-white-plains',
  phone: '914-467-7250',
  state: 'NY',
  district: 'nysb',
  coordinates: {
    latitude: 41.02849,
    longitude: -73.77065
  }
}, {
  name: 'United States Courthouse',
  address: {
    display: '355 Main Street Poughkeepsie, NY 12601',
    number: '355',
    street: 'Main Street',
    city: 'Poughkeepsie',
    state: 'NY',
    zipcode: '12601'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-southern-bankruptcy-court-poughkeepsie',
  phone: '845-452-4200',
  state: 'NY',
  district: 'nysb',
  coordinates: {
    latitude: 41.70271,
    longitude: -73.9252999
  }
}, {
  name: 'Edward R. Roybal Federal Building and Courthouse',
  address: {
    display: '255 East Temple Street Los Angeles, CA 90012',
    number: '255',
    street: 'East Temple Street',
    city: 'Los Angeles',
    state: 'CA',
    zipcode: '90012'
  },
  url: 'http://www.uscourts.gov/court-locator/california-central-bankruptcy-court-los-angeles',
  phone: '213-894-3118',
  state: 'CA',
  district: 'cacb',
  coordinates: {
    latitude: 34.05247,
    longitude: -118.2397
  }
}, {
  name: 'Warner Center',
  address: {
    display: '21041 Burbank Boulevard Woodland Hills, CA 91367',
    number: '21041',
    street: 'Burbank Boulevard',
    city: 'Woodland Hills',
    state: 'CA',
    zipcode: '91367'
  },
  url: 'http://www.uscourts.gov/court-locator/california-central-bankruptcy-court-woodland-hills',
  phone: '818-587-2900',
  state: 'CA',
  district: 'cacb',
  coordinates: {
    latitude: 34.17331,
    longitude: -118.59186
  }
}, {
  name: 'Ronald Reagan Federal Building and United States Courthouse',
  address: {
    display: '411 West Fourth Street Santa Ana, CA 92701',
    number: '411',
    street: 'West Fourth Street',
    city: 'Santa Ana',
    state: 'CA',
    zipcode: '92701'
  },
  url: 'http://www.uscourts.gov/court-locator/california-central-bankruptcy-court-santa-ana',
  phone: '714-338-5300',
  state: 'CA',
  district: 'cacb',
  coordinates: {
    latitude: 33.74797,
    longitude: -117.87121
  }
}, {
  name: '3420 Twelfth Street',
  address: {
    display: '3420 Twelfth Street Riverside, CA 92501',
    number: '3420',
    street: 'Twelfth Street',
    city: 'Riverside',
    state: 'CA',
    zipcode: '92501'
  },
  url: 'http://www.uscourts.gov/court-locator/california-central-bankruptcy-court-riverside',
  phone: '951-774-1000',
  state: 'CA',
  district: 'cacb',
  coordinates: {
    latitude: 33.9765802,
    longitude: -117.3739004
  }
}, {
  name: 'Everett McKinley Dirksen United States Courthouse',
  address: {
    display: '219 South Dearborn Street Chicago, IL 60604',
    number: '219',
    street: 'South Dearborn Street',
    city: 'Chicago',
    state: 'IL',
    zipcode: '60604'
  },
  url: 'http://www.uscourts.gov/court-locator/illinois-northern-bankruptcy-court-chicago',
  phone: '312-435-5694',
  state: 'IL',
  district: 'ilnb',
  coordinates: {
    latitude: 41.8791701,
    longitude: -87.6293223
  }
}, {
  name: 'Stanley J. Roszkowski United States Courthouse',
  address: {
    display: '327 South Church Street Rockford, IL 61101',
    number: '327',
    street: 'South Church Street',
    city: 'Rockford',
    state: 'IL',
    zipcode: '61101'
  },
  url: 'http://www.uscourts.gov/court-locator/illinois-northern-bankruptcy-court-rockford',
  phone: '815-987-4350',
  state: 'IL',
  district: 'ilnb',
  coordinates: {
    latitude: 42.2697073,
    longitude: -89.0973267
  }
}, {
  name: 'Bob Casey United States Courthouse',
  address: {
    display: '515 Rusk Street Houston, TX 77002',
    number: '515',
    street: 'Rusk Street',
    city: 'Houston',
    state: 'TX',
    zipcode: '77002'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-southern-bankruptcy-court-houston',
  phone: '713-250-5500',
  state: 'TX',
  district: 'txsb',
  coordinates: {
    latitude: 29.76085,
    longitude: -95.36775
  }
}, {
  name: 'Bentsen Tower',
  address: {
    display: '1701 West Business Highway 83 McAllen, TX 78501',
    number: '1701',
    street: 'West Business Highway 83',
    city: 'McAllen',
    state: 'TX',
    zipcode: '78501'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-southern-bankruptcy-court',
  phone: '956-618-8065',
  state: 'TX',
  district: 'txsb',
  coordinates: {
    latitude: 26.19629,
    longitude: -98.27811
  }
}, {
  name: 'Robert N.C. Nix, Sr. Federal Building',
  address: {
    display: '900 Market Street Philadelphia, PA 19107',
    number: '900',
    street: 'Market Street',
    city: 'Philadelphia',
    state: 'PA',
    zipcode: '19107'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-eastern-bankruptcy-court-philadelphia',
  phone: '215-408-2800',
  state: 'PA',
  district: 'paeb',
  coordinates: {
    latitude: 39.95137,
    longitude: -75.1553
  }
}, {
  name: 'Madison Building',
  address: {
    display: '400 Washington Street Reading, PA 19601',
    number: '400',
    street: 'Washington Street',
    city: 'Reading',
    state: 'PA',
    zipcode: '19601'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-eastern-bankruptcy-court-reading',
  phone: '610-208-5040',
  state: 'PA',
  district: 'paeb',
  coordinates: {
    latitude: 40.33701,
    longitude: -75.92929
  }
}, {
  name: 'Arizona Bankruptcy Court',
  address: {
    display: '230 N 1st Ave, Ste 101, Phoenix, AZ 85003',
    number: '230',
    street: 'N 1st Ave',
    city: 'Phoenix',
    state: 'AZ',
    zipcode: '85003'
  },
  url: 'https://www.uscourts.gov/federal-court-finder/location/440',
  phone: '602-682-4000',
  state: 'AZ',
  district: 'azb',
  coordinates: {
    latitude: 33.450949,
    longitude: -112.0757169
  }
}, {
  name: 'James A. Walsh United States Courthouse',
  address: {
    display: '38 South Scott Avenue Tucson, AZ 85701',
    number: '38',
    street: 'South Scott Avenue',
    city: 'Tucson',
    state: 'AZ',
    zipcode: '85701'
  },
  url: 'http://www.uscourts.gov/court-locator/arizona-bankruptcy-court-tucson',
  phone: '520-202-7500',
  state: 'AZ',
  district: 'azb',
  coordinates: {
    latitude: 32.22142,
    longitude: -110.96976
  }
}, {
  name: 'John M. Roll United States Courthouse',
  address: {
    display: '98 West 1st Street Yuma, AZ 85364',
    number: '98',
    street: 'West 1st Street',
    city: 'Yuma',
    state: 'AZ',
    zipcode: '85364'
  },
  url: 'http://www.uscourts.gov/court-locator/arizona-bankruptcy-court',
  phone: '602-682-4961',
  state: 'AZ',
  district: 'azb',
  coordinates: {
    latitude: 32.72522,
    longitude: -114.62074
  }
}, {
  name: 'Hipolito F. Garcia Federal Building and United States Courthouse',
  address: {
    display: '615 East Houston Street San Antonio, TX 78205',
    number: '615',
    street: 'East Houston Street',
    city: 'San Antonio',
    state: 'TX',
    zipcode: '78205'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-western-bankruptcy-court-san-antonio',
  phone: '210-472-6720',
  state: 'TX',
  district: 'txwb',
  coordinates: {
    latitude: 29.42651,
    longitude: -98.48652
  }
}, {
  name: 'Homer Thornberry Judicial Building',
  address: {
    display: '903 San Jacinto Boulevard Austin, TX 78701',
    number: '903',
    street: 'San Jacinto Boulevard',
    city: 'Austin',
    state: 'TX',
    zipcode: '78701'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-western-bankruptcy-court-austin',
  phone: '512-916-5237',
  state: 'TX',
  district: 'txwb',
  coordinates: {
    latitude: 30.270314,
    longitude: -97.7393144
  }
}, {
  name: 'Jacob Weinberger United States Courthouse',
  address: {
    display: '325 West F Street San Diego, CA 92101',
    number: '325',
    street: 'West F Street',
    city: 'San Diego',
    state: 'CA',
    zipcode: '92101'
  },
  url: 'http://www.uscourts.gov/court-locator/california-southern-bankruptcy-court-san-diego',
  phone: '619-557-5620',
  state: 'CA',
  district: 'casb',
  coordinates: {
    latitude: 32.71354,
    longitude: -117.16609
  }
}, {
  name: 'Earle Cabell Federal Building and United States Courthouse',
  address: {
    display: '1100 Commerce Street Dallas, TX 75242',
    number: '1100',
    street: 'Commerce Street',
    city: 'Dallas',
    state: 'TX',
    zipcode: '75242'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-northern-bankruptcy-court-dallas',
  phone: '214-753-2000',
  state: 'TX',
  district: 'txnb',
  coordinates: {
    latitude: 32.77927,
    longitude: -96.80201
  }
}, {
  name: 'Eldon B. Mahon United States Courthouse',
  address: {
    display: '501 West Tenth Street Fort Worth, TX 76102',
    number: '501',
    street: 'West Tenth Street',
    city: 'Fort Worth',
    state: 'TX',
    zipcode: '76102'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-northern-bankruptcy-court-fort-worth',
  phone: '817-333-6000',
  state: 'TX',
  district: 'txnb',
  coordinates: {
    latitude: 32.74991,
    longitude: -97.33342
  }
}, {
  name: 'George H. Mahon Federal Building and United States Courthouse',
  address: {
    display: '1205 Texas Avenue Lubbock, TX 79401',
    number: '1205',
    street: 'Texas Avenue',
    city: 'Lubbock',
    state: 'TX',
    zipcode: '79401'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-northern-bankruptcy-court-lubbock',
  phone: '806-472-5000',
  state: 'TX',
  district: 'txnb',
  coordinates: {
    latitude: 33.58359,
    longitude: -101.84558
  }
}, {
  name: 'J. Marvin Jones Federal Building',
  address: {
    display: '205 East Fifth Avenue Amarillo, TX 79101',
    number: '205',
    street: 'East Fifth Avenue',
    city: 'Amarillo',
    state: 'TX',
    zipcode: '79101'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-northern-bankruptcy-court-amarillo',
  phone: '806-324-2302',
  state: 'TX',
  district: 'txnb',
  coordinates: {
    latitude: 35.20844,
    longitude: -101.83497
  }
}, {
  name: 'Robert F. Peckham Federal Building and United States Courthouse',
  address: {
    display: '280 South First Street San Jose, CA 95113',
    number: '280',
    street: 'South First Street',
    city: 'San Jose',
    state: 'CA',
    zipcode: '95113'
  },
  url: 'http://www.uscourts.gov/court-locator/california-northern-bankruptcy-court-san-jose',
  phone: '888-821-7606',
  state: 'CA',
  district: 'canb',
  coordinates: {
    latitude: 37.3324903,
    longitude: -121.8879102
  }
}, {
  name: 'Oakland City Center',
  address: {
    display: '1300 Clay Street Oakland, CA 94612',
    number: '1300',
    street: 'Clay Street',
    city: 'Oakland',
    state: 'CA',
    zipcode: '94612'
  },
  url: 'http://www.uscourts.gov/court-locator/california-northern-bankruptcy-court-oakland',
  phone: '888-821-7606',
  state: 'CA',
  district: 'canb',
  coordinates: {
    latitude: 37.80485,
    longitude: -122.27388
  }
}, {
  name: 'Phillip Burton United States Courthouse',
  address: {
    display: '450 Golden Gate Avenue San Francisco, CA 94102',
    number: '450',
    street: 'Golden Gate Avenue',
    city: 'San Francisco',
    state: 'CA',
    zipcode: '94102'
  },
  url: 'http://www.uscourts.gov/court-locator/california-northern-bankruptcy-court-san-francisco',
  phone: '888-821-7606',
  state: 'CA',
  district: 'canb',
  coordinates: {
    latitude: 37.7813299,
    longitude: -122.41801
  }
}, {
  name: 'Birch Bayh Federal Building and United States Courthouse',
  address: {
    display: '46 East Ohio Street Indianapolis, IN 46204',
    number: '46',
    street: 'East Ohio Street',
    city: 'Indianapolis',
    state: 'IN',
    zipcode: '46204'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-southern-bankruptcy-court-indianapolis',
  phone: '317-229-3800',
  state: 'IN',
  district: 'insb',
  coordinates: {
    latitude: 39.76988,
    longitude: -86.1570799
  }
}, {
  name: 'Lee H. Hamilton Federal Building and United States Courthouse',
  address: {
    display: '121 West Spring Street New Albany, IN 47150',
    number: '121',
    street: 'West Spring Street',
    city: 'New Albany',
    state: 'IN',
    zipcode: '47150'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-southern-bankruptcy-court-new-albany',
  phone: '812-542-4540',
  state: 'IN',
  district: 'insb',
  coordinates: {
    latitude: 38.28541,
    longitude: -85.8249699
  }
}, {
  name: 'Federal Building',
  address: {
    display: '101 NW Martin Luther King Jr. Boulevard Evansville, IN 47708',
    number: '101',
    street: 'NW Martin Luther King Jr. Boulevard',
    city: 'Evansville',
    state: 'IN',
    zipcode: '47708'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-southern-bankruptcy-court-evansville',
  phone: '812-434-6470',
  state: 'IN',
  district: 'insb',
  coordinates: {
    latitude: 37.9755601,
    longitude: -87.5695138
  }
}, {
  name: 'Bryan Simpson United States Courthouse',
  address: {
    display: '300 North Hogan Street Jacksonville, FL 32202',
    number: '300',
    street: 'North Hogan Street',
    city: 'Jacksonville',
    state: 'FL',
    zipcode: '32202'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-middle-bankruptcy-court-jacksonville',
  phone: '904-301-6490',
  state: 'FL',
  district: 'flmb',
  coordinates: {
    latitude: 30.32944,
    longitude: -81.65985
  }
}, {
  name: 'George C. Young United States Courthouse',
  address: {
    display: '400 West Washington Street Orlando, FL 32801',
    number: '400',
    street: 'West Washington Street',
    city: 'Orlando',
    state: 'FL',
    zipcode: '32801'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-middle-bankruptcy-court-orlando',
  phone: '407-237-8000',
  state: 'FL',
  district: 'flmb',
  coordinates: {
    latitude: 28.54386,
    longitude: -81.38376
  }
}, {
  name: 'Sam M. Gibbons United States Courthouse',
  address: {
    display: '801 North Florida Avenue Tampa, FL 33602',
    number: '801',
    street: 'North Florida Avenue',
    city: 'Tampa',
    state: 'FL',
    zipcode: '33602'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-middle-bankruptcy-court-tampa',
  phone: '813-301-5046',
  state: 'FL',
  district: 'flmb',
  coordinates: {
    latitude: 27.95118,
    longitude: -82.45851
  }
}, {
  name: 'United States Courthouse and Federal Building',
  address: {
    display: '2110 First Street Fort Myers, FL 33901',
    number: '2110',
    street: 'First Street',
    city: 'Fort Myers',
    state: 'FL',
    zipcode: '33901'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-middle-bankruptcy-court-fort-myers',
  phone: '239-461-2110',
  state: 'FL',
  district: 'flmb',
  coordinates: {
    latitude: 26.64354,
    longitude: -81.87133
  }
}, {
  name: 'Schaaf Building',
  address: {
    display: '170 North High Street Columbus, OH 43215',
    number: '170',
    street: 'North High Street',
    city: 'Columbus',
    state: 'OH',
    zipcode: '43215'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-southern-bankruptcy-court-columbus',
  phone: '614-469-6638',
  state: 'OH',
  district: 'ohsb',
  coordinates: {
    latitude: 39.9659,
    longitude: -83.00136
  }
}, {
  name: 'Old Post Office Building',
  address: {
    display: '120 West Third Street Dayton, OH 45402',
    number: '120',
    street: 'West Third Street',
    city: 'Dayton',
    state: 'OH',
    zipcode: '45402'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-southern-bankruptcy-court-dayton',
  phone: '937-225-2516',
  state: 'OH',
  district: 'ohsb',
  coordinates: {
    latitude: 39.75902,
    longitude: -84.19505
  }
}, {
  name: 'Atrium Two',
  address: {
    display: '221 East Fourth Street Cincinnati, OH 45202',
    number: '221',
    street: 'East Fourth Street',
    city: 'Cincinnati',
    state: 'OH',
    zipcode: '45202'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-southern-bankruptcy-court-cincinnati',
  phone: '513-684-2572',
  state: 'OH',
  district: 'ohsb',
  coordinates: {
    latitude: 39.10062,
    longitude: -84.50821
  }
}, {
  name: 'Old Post Office Building',
  address: {
    display: '215 Dean A. McGee Avenue Oklahoma City, OK 73102',
    number: '215',
    street: 'Dean A. McGee Avenue',
    city: 'Oklahoma City',
    state: 'OK',
    zipcode: '73102'
  },
  url: 'http://www.uscourts.gov/court-locator/oklahoma-western-bankruptcy-court-oklahoma-city',
  phone: '405-609-5700',
  state: 'OK',
  district: 'okwb',
  coordinates: {
    latitude: 35.4717266,
    longitude: -97.5180033
  }
}, {
  name: 'United States Post Office and Courthouse',
  address: {
    display: '101 N. 5th Street, Room 403 Okmulgee, OK 74447',
    number: '101',
    street: 'N. 5th Street',
    street2: 'Room 403',
    city: 'Okmulgee',
    state: 'OK',
    zipcode: '74447'
  },
  mailingAddress: {
    display: 'P.O. Box 1888 Muskogee, OK 74402',
    street: 'P.O. Box 1888',
    city: 'Muskogee',
    state: 'OK',
    zipcode: '74402'
  },
  url: 'http://www.uscourts.gov/court-locator/oklahoma-eastern-bankruptcy-court-okmulgee',
  phone: '918-549-7200',
  state: 'OK',
  district: 'okeb',
  coordinates: {
    latitude: 35.6239602,
    longitude: -95.9739292
  }
}, {
  name: 'Federal Building',
  address: {
    display: '224 South Boulder Avenue Tulsa, OK 74103',
    number: '224',
    street: 'South Boulder Avenue',
    city: 'Tulsa',
    state: 'OK',
    zipcode: '74103'
  },
  url: 'http://www.uscourts.gov/court-locator/oklahoma-northern-bankruptcy-court-tulsa',
  phone: '918-699-4000',
  state: 'OK',
  district: 'oknb',
  coordinates: {
    latitude: 36.1532969,
    longitude: -95.9949366
  }
}, {
  name: 'Charles R. Jonas Federal Building',
  address: {
    display: '401 West Trade Street Charlotte, NC 28202',
    number: '401',
    street: 'West Trade Street',
    city: 'Charlotte',
    state: 'NC',
    zipcode: '28202'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-western-bankruptcy-court-charlotte',
  phone: '704-350-7500',
  state: 'NC',
  district: 'ncwb',
  coordinates: {
    latitude: 35.22984,
    longitude: -80.84613
  }
}, {
  name: 'Gateway Plaza Building',
  address: {
    display: '402 West Trade Street Charlotte, NC 28202',
    number: '402',
    street: 'West Trade Street',
    city: 'Charlotte',
    state: 'NC',
    zipcode: '28202'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-western-bankruptcy-administrator-charlotte',
  phone: '704-350-7587',
  state: 'NC',
  district: 'ncwb',
  coordinates: {
    latitude: 35.22974,
    longitude: -80.84601
  }
}, {
  name: 'United States Post Office',
  address: {
    display: '200 West Broad Street Statesville, NC 28677',
    number: '200',
    street: 'West Broad Street',
    city: 'Statesville',
    state: 'NC',
    zipcode: '28677'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-western-bankruptcy-court-statesville',
  phone: '704-871-4280',
  state: 'NC',
  district: 'ncwb',
  coordinates: {
    latitude: 35.78403,
    longitude: -80.89021
  }
}, {
  name: '211 West Fort Street',
  address: {
    display: '211 West Fort Street Detroit, MI 48226',
    number: '211',
    street: 'West Fort Street',
    city: 'Detroit',
    state: 'MI',
    zipcode: '48226'
  },
  url: 'http://www.uscourts.gov/court-locator/michigan-eastern-bankruptcy-court-detroit',
  phone: '313-234-0065',
  state: 'MI',
  district: 'mieb',
  coordinates: {
    latitude: 42.32985,
    longitude: -83.04944
  }
}, {
  name: 'Goodyear Building',
  address: {
    display: '226 West Second Street Flint, MI 48502',
    number: '226',
    street: 'West Second Street',
    city: 'Flint',
    state: 'MI',
    zipcode: '48502'
  },
  url: 'http://www.uscourts.gov/court-locator/michigan-eastern-bankruptcy-court-flint',
  phone: '810-235-4126',
  state: 'MI',
  district: 'mieb',
  coordinates: {
    latitude: 43.01397,
    longitude: -83.69219
  }
}, {
  name: 'One Memphis Place',
  address: {
    display: '200 Jefferson Avenue Memphis, TN 38103',
    number: '200',
    street: 'Jefferson Avenue',
    city: 'Memphis',
    state: 'TN',
    zipcode: '38103'
  },
  url: 'http://www.uscourts.gov/court-locator/tennessee-western-bankruptcy-court-memphis',
  phone: '901-328-3500',
  state: 'TN',
  district: 'tnwb',
  coordinates: {
    latitude: 35.14642,
    longitude: -90.04917
  }
}, {
  name: 'United States Custom House',
  address: {
    display: '721 19th Street Denver, CO 80202',
    number: '721',
    street: '19th Street',
    city: 'Denver',
    state: 'CO',
    zipcode: '80202'
  },
  url: 'http://www.uscourts.gov/court-locator/colorado-bankruptcy-court-denver',
  phone: '720-904-7300',
  state: 'CO',
  district: 'cob',
  coordinates: {
    latitude: 39.74844,
    longitude: -104.98914
  }
}, {
  name: 'E. Barrett Prettyman United States Courthouse',
  address: {
    display: '333 Constitution Avenue Washington, DC 20001',
    number: '333',
    street: 'Constitution Avenue',
    city: 'Washington',
    state: 'DC',
    zipcode: '20001'
  },
  url: 'http://www.uscourts.gov/court-locator/district-columbia-bankruptcy-court-washington',
  phone: '202-354-3000',
  state: 'DC',
  district: 'dcb',
  coordinates: {
    latitude: 38.89199,
    longitude: -77.01597
  }
}, {
  name: 'John W. McCormack Post Office and Court House',
  address: {
    display: '5 Post Office Square Boston, MA 02109',
    number: '5',
    street: 'Post Office Square',
    city: 'Boston',
    state: 'MA',
    zipcode: '02109'
  },
  url: 'http://www.uscourts.gov/court-locator/massachusetts-bankruptcy-court-boston',
  phone: '617-748-5300',
  state: 'MA',
  district: 'mab',
  coordinates: {
    latitude: 42.35722,
    longitude: -71.05637
  }
}, {
  name: 'Harold D. Donohue Federal Building and United States Courthouse',
  address: {
    display: '595 Main Street Worcester, MA 01608',
    number: '595',
    street: 'Main Street',
    city: 'Worcester',
    state: 'MA',
    zipcode: '01608'
  },
  url: 'http://www.uscourts.gov/court-locator/massachusetts-bankruptcy-court-worcester',
  phone: '508-770-8900',
  state: 'MA',
  district: 'mab',
  coordinates: {
    latitude: 42.2605879,
    longitude: -71.8040151
  }
}, {
  name: '300 State Street',
  address: {
    display: '300 State Street Springfield, MA 01105',
    number: '300',
    street: 'State Street',
    city: 'Springfield',
    state: 'MA',
    zipcode: '01105'
  },
  url: 'http://www.uscourts.gov/court-locator/massachusetts-bankruptcy-court-springfield',
  phone: '413-785-6900',
  state: 'MA',
  district: 'mab',
  coordinates: {
    latitude: 42.10502,
    longitude: -72.58205
  }
}, {
  name: 'United States Customs House',
  address: {
    display: '701 Broadway Nashville, TN 37203',
    number: '701',
    street: 'Broadway',
    city: 'Nashville',
    state: 'TN',
    zipcode: '37203'
  },
  url: 'http://www.uscourts.gov/court-locator/tennessee-middle-bankruptcy-court-nashville',
  phone: '615-736-5584',
  state: 'TN',
  district: 'tnmb',
  coordinates: {
    latitude: 36.15914,
    longitude: -86.7815
  }
}, {
  name: 'Edward A. Garmatz Federal Building and United States Courthouse',
  address: {
    display: '101 West Lombard Street Baltimore, MD 21201',
    number: '101',
    street: 'West Lombard Street',
    city: 'Baltimore',
    state: 'MD',
    zipcode: '21201'
  },
  url: 'http://www.uscourts.gov/court-locator/maryland-bankruptcy-court-baltimore',
  phone: '410-962-2688',
  state: 'MD',
  district: 'mdb',
  coordinates: {
    latitude: 39.28768,
    longitude: -76.6164433
  }
}, {
  name: 'Gene Snyder United States Courthouse',
  address: {
    display: '601 West Broadway Louisville, KY 40202',
    number: '601',
    street: 'West Broadway',
    city: 'Louisville',
    state: 'KY',
    zipcode: '40202'
  },
  url: 'http://www.uscourts.gov/court-locator/kentucky-western-bankruptcy-court-louisville',
  phone: '502-627-5700',
  state: 'KY',
  district: 'kywb',
  coordinates: {
    latitude: 38.24632,
    longitude: -85.7617999
  }
}, {
  name: 'Congress Center',
  address: {
    display: '1001 Southwest Fifth Avenue Portland, OR 97204',
    number: '1001',
    street: 'Southwest Fifth Avenue',
    city: 'Portland',
    state: 'OR',
    zipcode: '97204'
  },
  url: 'http://www.uscourts.gov/court-locator/oregon-bankruptcy-court-portland',
  phone: '503-326-1500',
  state: 'OR',
  district: 'orb',
  coordinates: {
    latitude: 45.51647,
    longitude: -122.67883
  }
}, {
  name: 'Wayne Lyman Morse United States Courthouse',
  address: {
    display: '405 East Eighth Avenue Eugene, OR 97401',
    number: '405',
    street: 'East Eighth Avenue',
    city: 'Eugene',
    state: 'OR',
    zipcode: '97401'
  },
  url: 'http://www.uscourts.gov/court-locator/oregon-bankruptcy-court-eugene',
  phone: '541-431-4000',
  state: 'OR',
  district: 'orb',
  coordinates: {
    latitude: 44.05103,
    longitude: -123.08577
  }
}, {
  name: 'Foley Federal Building',
  address: {
    display: '300 Las Vegas Boulevard South Las Vegas, NV 89101',
    number: '300',
    street: 'Las Vegas Boulevard South',
    city: 'Las Vegas',
    state: 'NV',
    zipcode: '89101'
  },
  url: 'http://www.uscourts.gov/court-locator/nevada-bankruptcy-court-las-vegas',
  phone: '702-527-7000',
  state: 'NV',
  district: 'nvb',
  coordinates: {
    latitude: 36.16631,
    longitude: -115.14266
  }
}, {
  name: 'C. Clifton Young Federal Building and United States Courthouse',
  address: {
    display: '300 Booth Street Reno, NV 89509',
    number: '300',
    street: 'Booth Street',
    city: 'Reno',
    state: 'NV',
    zipcode: '89509'
  },
  url: 'http://www.uscourts.gov/court-locator/nevada-bankruptcy-court-reno',
  phone: '775-326-2100',
  state: 'NV',
  district: 'nvb',
  coordinates: {
    latitude: 39.51804,
    longitude: -119.82643
  }
}, {
  name: 'Pete V. Domenici United States Courthouse',
  address: {
    display: '333 Lomas Boulevard Albuquerque, NM 87102',
    number: '333',
    street: 'Lomas Boulevard',
    city: 'Albuquerque',
    state: 'NM',
    zipcode: '87102'
  },
  url: 'http://www.uscourts.gov/court-locator/new-mexico-bankruptcy-court-albuquerque',
  phone: '505-415-7999',
  state: 'NM',
  district: 'nmb',
  coordinates: {
    latitude: 35.09024,
    longitude: -106.64239
  }
}, {
  name: 'Robert E. Coyle United States Courthouse',
  address: {
    display: '2500 Tulare Street Fresno, CA 93721',
    number: '2500',
    street: 'Tulare Street',
    city: 'Fresno',
    state: 'CA',
    zipcode: '93721'
  },
  url: 'http://www.uscourts.gov/court-locator/california-eastern-bankruptcy-court-fresno',
  phone: '559-499-5800',
  state: 'CA',
  district: 'caeb',
  coordinates: {
    latitude: 36.73762,
    longitude: -119.78478
  }
}, {
  name: '1200 I Street',
  address: {
    display: '1200 I Street Modesto, CA 95354',
    number: '1200',
    street: 'I Street',
    city: 'Modesto',
    state: 'CA',
    zipcode: '95354'
  },
  url: 'http://www.uscourts.gov/court-locator/california-eastern-bankruptcy-court-modesto',
  phone: '209-521-5160',
  state: 'CA',
  district: 'caeb',
  coordinates: {
    latitude: 37.6412,
    longitude: -120.99703
  }
}, {
  name: 'Robert T. Matsui United States Courthouse',
  address: {
    display: '501 I Street Sacramento, CA 95814',
    number: '501',
    street: 'I Street',
    city: 'Sacramento',
    state: 'CA',
    zipcode: '95814'
  },
  url: 'http://www.uscourts.gov/court-locator/california-eastern-bankruptcy-court-sacramento',
  phone: '916-930-4400',
  state: 'CA',
  district: 'caeb',
  coordinates: {
    latitude: 38.58299,
    longitude: -121.49898
  }
}, {
  name: 'Charles Evans Whittaker United States Courthouse',
  address: {
    display: '400 East Ninth Street Kansas City, MO 64106',
    number: '400',
    street: 'East Ninth Street',
    city: 'Kansas City',
    state: 'MO',
    zipcode: '64106'
  },
  url: 'http://www.uscourts.gov/court-locator/missouri-western-bankruptcy-court-kansas-city',
  phone: '816-512-5000',
  state: 'MO',
  district: 'mowb',
  coordinates: {
    latitude: 39.1034,
    longitude: -94.5782347
  }
}, {
  name: 'Christopher S. Bond United States Courthouse',
  address: {
    display: '80 Lafayette Street Jefferson City, MO 65101',
    number: '80',
    street: 'Lafayette Street',
    city: 'Jefferson City',
    state: 'MO',
    zipcode: '65101'
  },
  url: 'http://www.uscourts.gov/court-locator/missouri-western-bankruptcy-court-jefferson-city',
  phone: '573-636-4015',
  state: 'MO',
  district: 'mowb',
  coordinates: {
    latitude: 38.5745718,
    longitude: -92.1645256
  }
}, {
  name: 'Walter E. Hoffman United States Courthouse',
  address: {
    display: '600 Granby Street Norfolk, VA 23510',
    number: '600',
    street: 'Granby Street',
    city: 'Norfolk',
    state: 'VA',
    zipcode: '23510'
  },
  url: 'http://www.uscourts.gov/court-locator/virginia-eastern-bankruptcy-court-norfolk',
  phone: '757-222-7500',
  state: 'VA',
  district: 'vaeb',
  coordinates: {
    latitude: 36.85357,
    longitude: -76.28877
  }
}, {
  name: 'Spottswood W. Robinson III & Robert R. Merhige, Jr., U.S. Courthouse',
  address: {
    display: '701 East Broad Street Richmond, VA 23219',
    number: '701',
    street: 'East Broad Street',
    city: 'Richmond',
    state: 'VA',
    zipcode: '23219'
  },
  url: 'http://www.uscourts.gov/court-locator/virginia-eastern-bankruptcy-court-richmond',
  phone: '804-916-2400',
  state: 'VA',
  district: 'vaeb',
  coordinates: {
    latitude: 37.54181,
    longitude: -77.43548
  }
}, {
  name: 'Martin V.B. Bostetter, Jr. United States Courthouse',
  address: {
    display: '200 South Washington Street Alexandria, VA 22314',
    number: '200',
    street: 'South Washington Street',
    city: 'Alexandria',
    state: 'VA',
    zipcode: '22314'
  },
  url: 'http://www.uscourts.gov/court-locator/virginia-eastern-bankruptcy-court-alexandria',
  phone: '703-258-1200',
  state: 'VA',
  district: 'vaeb',
  coordinates: {
    latitude: 38.80372,
    longitude: -77.04728
  }
}, {
  name: 'Richard B. Russell Federal Building and United States Courthouse',
  address: {
    display: '75 Ted Turner Drive Atlanta, GA 30303',
    number: '75',
    street: 'Ted Turner Drive',
    city: 'Atlanta',
    state: 'GA',
    zipcode: '30303'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-northern-bankruptcy-court-atlanta',
  phone: '404-215-1000',
  state: 'GA',
  district: 'ganb',
  coordinates: {
    latitude: 33.75303,
    longitude: -84.39515
  }
}, {
  name: 'Lewis R. Morgan Federal Building and United States Courthouse',
  address: {
    display: '18 Greenville Street Newnan, GA 30263',
    number: '18',
    street: 'Greenville Street',
    city: 'Newnan',
    state: 'GA',
    zipcode: '30263'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-northern-bankruptcy-court-newnan',
  phone: '678-423-3000',
  state: 'GA',
  district: 'ganb',
  coordinates: {
    latitude: 33.37338,
    longitude: -84.79973
  }
}, {
  name: 'Roman L. Hruska United States Courthouse',
  address: {
    display: '111 South 18th Plaza Omaha, NE 68102',
    number: '111',
    street: 'South 18th Plaza',
    city: 'Omaha',
    state: 'NE',
    zipcode: '68102'
  },
  url: 'http://www.uscourts.gov/court-locator/nebraska-bankruptcy-court-omaha',
  phone: '402-661-7444',
  state: 'NE',
  district: 'neb',
  coordinates: {
    latitude: 41.25916,
    longitude: -95.93983
  }
}, {
  name: 'Robert V. Denney United States Courthouse',
  address: {
    display: '100 Centennial Mall North Lincoln, NE 68508',
    number: '100',
    street: 'Centennial Mall North',
    city: 'Lincoln',
    state: 'NE',
    zipcode: '68508'
  },
  url: 'http://www.uscourts.gov/court-locator/nebraska-bankruptcy-court-lincoln',
  phone: '402-437-1625',
  state: 'NE',
  district: 'neb',
  coordinates: {
    latitude: 40.81417,
    longitude: -96.69962
  }
}, {
  name: 'Century Station',
  address: {
    display: '300 Fayetteville Street Raleigh, NC 27601',
    number: '300',
    street: 'Fayetteville Street',
    city: 'Raleigh',
    state: 'NC',
    zipcode: '27601'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-eastern-bankruptcy-court-raleigh',
  phone: '919-856-4752',
  state: 'NC',
  district: 'nceb',
  coordinates: {
    latitude: 35.77672,
    longitude: -78.6393
  }
}, {
  name: '434 Fayetteville Street',
  address: {
    display: '434 Fayetteville Street Raleigh, NC 27601',
    number: '434',
    street: 'Fayetteville Street',
    city: 'Raleigh',
    state: 'NC',
    zipcode: '27601'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-eastern-bankruptcy-administrator-raleigh',
  phone: '919-856-4886',
  state: 'NC',
  district: 'nceb',
  coordinates: {
    latitude: 35.77437,
    longitude: -78.63942
  }
}, {
  name: '150 Reade Circle',
  address: {
    display: '150 Reade Circle Greenville, NC 27858',
    number: '150',
    street: 'Reade Circle',
    city: 'Greenville',
    state: 'NC',
    zipcode: '27858'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-eastern-bankruptcy-administrator-greenville',
  phone: '919-856-4886',
  state: 'NC',
  district: 'nceb',
  coordinates: {
    latitude: 35.60922,
    longitude: -77.3729
  }
}, {
  name: 'C. Clyde Atkins United States Courthouse',
  address: {
    display: '301 North Miami Avenue Miami, FL 33128',
    number: '301',
    street: 'North Miami Avenue',
    city: 'Miami',
    state: 'FL',
    zipcode: '33128'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-southern-bankruptcy-court-miami',
  phone: '305-714-1800',
  state: 'FL',
  district: 'flsb',
  coordinates: {
    latitude: 25.7773499,
    longitude: -80.19372
  }
}, {
  name: 'The Flagler Waterview Building',
  address: {
    display: '1515 North Flagler Drive West Palm Beach, FL 33401',
    number: '1515',
    street: 'North Flagler Drive',
    city: 'West Palm Beach',
    state: 'FL',
    zipcode: '33401'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-southern-bankruptcy-court-west-palm-beach',
  phone: '561-514-4100',
  state: 'FL',
  district: 'flsb',
  coordinates: {
    latitude: 26.7264603,
    longitude: -80.0533234
  }
}, {
  name: 'Warren E. Burger Federal Building',
  address: {
    display: '316 North Robert Street St. Paul, MN 55101',
    number: '316',
    street: 'North Robert Street',
    city: 'St. Paul',
    state: 'MN',
    zipcode: '55101'
  },
  url: 'http://www.uscourts.gov/court-locator/minnesota-bankruptcy-court-st-paul',
  phone: '651-848-1000',
  state: 'MN',
  district: 'mnb',
  coordinates: {
    latitude: 44.9461675,
    longitude: -93.089655
  }
}, {
  name: 'Gerald W. Heaney Federal Building and United States Courthouse',
  address: {
    display: '515 West First Street Duluth, MN 55802',
    number: '515',
    street: 'West First Street',
    city: 'Duluth',
    state: 'MN',
    zipcode: '55802'
  },
  url: 'http://www.uscourts.gov/court-locator/minnesota-bankruptcy-court-duluth',
  phone: '218-529-3600',
  state: 'MN',
  district: 'mnb',
  coordinates: {
    latitude: 46.78228,
    longitude: -92.10628
  }
}, {
  name: 'Howard M. Metzenbaum United States Courthouse',
  address: {
    display: '201 Superior Avenue Cleveland, OH 44114',
    number: '201',
    street: 'Superior Avenue',
    city: 'Cleveland',
    state: 'OH',
    zipcode: '44114'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-northern-bankruptcy-court-cleveland',
  phone: '216-615-4300',
  state: 'OH',
  district: 'ohnb',
  coordinates: {
    latitude: 41.50031,
    longitude: -81.6924
  }
}, {
  name: 'John F. Seiberling Federal Building and United States Courthouse',
  address: {
    display: 'Two South Main Street Akron, OH 44308',
    number: null,
    street: 'Two South Main Street',
    city: 'Akron',
    state: 'OH',
    zipcode: '44308'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-northern-bankruptcy-court-akron',
  phone: '330-252-6100',
  state: 'OH',
  district: 'ohnb',
  coordinates: {
    latitude: 41.0849199,
    longitude: -81.51697
  }
}, {
  name: 'Ralph Regula Federal Building and United States Courthouse',
  address: {
    display: '401 McKinley Ave SW Canton, OH 44702',
    number: '401',
    street: 'McKinley Ave SW',
    city: 'Canton',
    state: 'OH',
    zipcode: '44702'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-northern-bankruptcy-court-canton',
  phone: '330-458-2120',
  state: 'OH',
  district: 'ohnb',
  coordinates: {
    latitude: 40.79683,
    longitude: -81.37914
  }
}, {
  name: 'Nathaniel R. Jones Federal Building and United States Courthouse',
  address: {
    display: '10 East Commerce Street Youngstown, OH 44503',
    number: '10',
    street: 'East Commerce Street',
    city: 'Youngstown',
    state: 'OH',
    zipcode: '44503'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-northern-bankruptcy-court-youngstown',
  phone: '330-742-0900',
  state: 'OH',
  district: 'ohnb',
  coordinates: {
    latitude: 41.10061,
    longitude: -80.64765
  }
}, {
  name: 'Frank Carlson Federal Building and United States Courthouse',
  address: {
    display: '444 Southeast Quincy Street Topeka, KS 66683',
    number: '444',
    street: 'Southeast Quincy Street',
    city: 'Topeka',
    state: 'KS',
    zipcode: '66683'
  },
  url: 'http://www.uscourts.gov/court-locator/kansas-bankruptcy-court-topeka',
  phone: '785-338-5910',
  state: 'KS',
  district: 'ksb',
  coordinates: {
    latitude: 39.05303,
    longitude: -95.6711
  }
}, {
  name: 'Robert J. Dole United States Courthouse',
  address: {
    display: '500 State Avenue Kansas City, KS 66101',
    number: '500',
    street: 'State Avenue',
    city: 'Kansas City',
    state: 'KS',
    zipcode: '66101'
  },
  url: 'http://www.uscourts.gov/court-locator/kansas-bankruptcy-court-kansas-city',
  phone: '913-735-2110',
  state: 'KS',
  district: 'ksb',
  coordinates: {
    latitude: 39.1165499,
    longitude: -94.62259
  }
}, {
  name: 'Hale Boggs Federal Building United States Courthouse',
  address: {
    display: '500 Poydras Street New Orleans, LA 70130',
    number: '500',
    street: 'Poydras Street',
    city: 'New Orleans',
    state: 'LA',
    zipcode: '70130'
  },
  url: 'http://www.uscourts.gov/court-locator/louisiana-eastern-bankruptcy-court-new-orleans',
  phone: '504-589-7878',
  state: 'LA',
  district: 'laeb',
  coordinates: {
    latitude: 29.949,
    longitude: -90.06844
  }
}, {
  name: '1132 Bishop Street',
  address: {
    display: '1132 Bishop Street Honolulu, HI 96813',
    number: '1132',
    street: 'Bishop Street',
    city: 'Honolulu',
    state: 'HI',
    zipcode: '96813'
  },
  url: 'http://www.uscourts.gov/court-locator/hawaii-bankruptcy-court-honolulu',
  phone: '808-522-8100',
  state: 'HI',
  district: 'hib',
  coordinates: {
    latitude: 21.310078,
    longitude: -157.8625671
  }
}, {
  name: 'Thomas F. Eagleton United States Courthouse',
  address: {
    display: '111 South Tenth Street St. Louis, MO 63102',
    number: '111',
    street: 'South Tenth Street',
    city: 'St. Louis',
    state: 'MO',
    zipcode: '63102'
  },
  url: 'http://www.uscourts.gov/court-locator/missouri-eastern-bankruptcy-court-st-louis',
  phone: '314-244-4500',
  state: 'MO',
  district: 'moeb',
  coordinates: {
    latitude: 38.6258622,
    longitude: -90.1959058
  }
}, {
  name: 'Community Trust Building',
  address: {
    display: '100 East Vine Street Lexington, KY 40507',
    number: '100',
    street: 'East Vine Street',
    city: 'Lexington',
    state: 'KY',
    zipcode: '40507'
  },
  url: 'http://www.uscourts.gov/court-locator/kentucky-eastern-bankruptcy-court-lexington',
  phone: '859-233-2608',
  state: 'KY',
  district: 'kyeb',
  coordinates: {
    latitude: 38.0454,
    longitude: -84.4978299
  }
}, {
  name: 'USX Tower',
  address: {
    display: '600 Grant Street Pittsburgh, PA 15219',
    number: '600',
    street: 'Grant Street',
    city: 'Pittsburgh',
    state: 'PA',
    zipcode: '15219'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-western-bankruptcy-court-pittsburgh',
  phone: '412-644-4060',
  state: 'PA',
  district: 'pawb',
  coordinates: {
    latitude: 40.44145,
    longitude: -79.99542
  }
}, {
  name: '17 South Park Row',
  address: {
    display: '17 South Park Row Erie, PA 16501',
    number: '17',
    street: 'South Park Row',
    city: 'Erie',
    state: 'PA',
    zipcode: '16501'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-western-bankruptcy-court-erie',
  phone: '814-464-9740',
  state: 'PA',
  district: 'pawb',
  coordinates: {
    latitude: 42.1289,
    longitude: -80.08531
  }
}, {
  name: 'Old Federal Building',
  address: {
    display: '605 West Fourth Avenue Anchorage, AK 99501',
    number: '605',
    street: 'West Fourth Avenue',
    city: 'Anchorage',
    state: 'AK',
    zipcode: '99501'
  },
  url: 'http://www.uscourts.gov/court-locator/alaska-bankruptcy-court-anchorage',
  phone: '907-271-2655',
  state: 'AK',
  district: 'akb',
  coordinates: {
    latitude: 61.21855,
    longitude: -149.8942999
  }
}, {
  name: 'Federal Building and United States Courthouse',
  address: {
    display: '101 12th Avenue Fairbanks, AK 99701',
    number: '101',
    street: '12th Avenue',
    city: 'Fairbanks',
    state: 'AK',
    zipcode: '99701'
  },
  url: 'http://www.uscourts.gov/court-locator/alaska-bankruptcy-court-fairbanks',
  phone: '907-456-0349',
  state: 'AK',
  district: 'akb',
  coordinates: {
    latitude: 64.8384065,
    longitude: -147.7066994
  }
}, {
  name: 'James M. Ashley and Thomas W.L. Ashley United States Courthouse',
  address: {
    display: '1716 Spielbusch Avenue Toledo, OH 43604',
    number: '1716',
    street: 'Spielbusch Avenue',
    city: 'Toledo',
    state: 'OH',
    zipcode: '43604'
  },
  url: 'http://www.uscourts.gov/court-locator/ohio-northern-bankruptcy-court-toledo',
  phone: '419-213-5600',
  state: 'OH',
  district: 'ohnb',
  coordinates: {
    latitude: 41.6577,
    longitude: -83.53659
  }
}, {
  name: 'Federal Law Center',
  address: {
    display: '101 South Edgeworth Street Greensboro, NC 27401',
    number: '101',
    street: 'South Edgeworth Street',
    city: 'Greensboro',
    state: 'NC',
    zipcode: '27401'
  },
  url: 'http://www.uscourts.gov/court-locator/north-carolina-middle-bankruptcy-court-greensboro',
  phone: '336-358-4000',
  state: 'NC',
  district: 'ncmb',
  coordinates: {
    latitude: 36.07231,
    longitude: -79.7962
  }
}, {
  name: 'Martin Luther King, Jr. Federal Building and United States Courthouse',
  address: {
    display: '50 Walnut Street Newark, NJ 07102',
    number: '50',
    street: 'Walnut Street',
    city: 'Newark',
    state: 'NJ',
    zipcode: '07102'
  },
  url: 'http://www.uscourts.gov/court-locator/new-jersey-bankruptcy-court-newark',
  phone: '973-645-4764',
  state: 'NJ',
  district: 'njb',
  coordinates: {
    latitude: 40.7299982,
    longitude: -74.1728026
  }
}, {
  name: 'Clarkson S. Fisher Federal Building and United States Courthouse',
  address: {
    display: '402 East State Street Trenton, NJ 08608',
    number: '402',
    street: 'East State Street',
    city: 'Trenton',
    state: 'NJ',
    zipcode: '08608'
  },
  url: 'http://www.uscourts.gov/court-locator/new-jersey-bankruptcy-court-trenton',
  phone: '609-858-9333',
  state: 'NJ',
  district: 'njb',
  coordinates: {
    latitude: 40.22088,
    longitude: -74.7573
  }
}, {
  name: 'United States Post Office and Courthouse',
  address: {
    display: '401 Market Street Camden, NJ 08101',
    number: '401',
    street: 'Market Street',
    city: 'Camden',
    state: 'NJ',
    zipcode: '08101'
  },
  url: 'http://www.uscourts.gov/court-locator/new-jersey-bankruptcy-court-camden',
  phone: '856-361-2300',
  state: 'NJ',
  district: 'njb',
  coordinates: {
    latitude: 39.94576,
    longitude: -75.12201
  }
}, {
  name: 'Wells Fargo Bank Building',
  address: {
    display: '660 North Central Expressway Plano, TX 75074',
    number: '660',
    street: 'North Central Expressway',
    city: 'Plano',
    state: 'TX',
    zipcode: '75074'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-eastern-bankruptcy-court-plano',
  phone: '972-509-1240',
  state: 'TX',
  district: 'txeb',
  coordinates: {
    latitude: 33.00808,
    longitude: -96.70735
  }
}, {
  name: 'Plaza Tower',
  address: {
    display: '110 North College Avenue Tyler, TX 75702',
    number: '110',
    street: 'North College Avenue',
    city: 'Tyler',
    state: 'TX',
    zipcode: '75702'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-eastern-bankruptcy-court-tyler',
  phone: '903-590-3200',
  state: 'TX',
  district: 'txeb',
  coordinates: {
    latitude: 32.35081,
    longitude: -95.30165
  }
}, {
  name: 'Jack Brooks Federal Building and United States Courthouse',
  address: {
    display: '300 Willow Street Beaumont, TX 77701',
    number: '300',
    street: 'Willow Street',
    city: 'Beaumont',
    state: 'TX',
    zipcode: '77701'
  },
  url: 'http://www.uscourts.gov/court-locator/texas-eastern-bankruptcy-court-beaumont',
  phone: '409-839-2617',
  state: 'TX',
  district: 'txeb',
  coordinates: {
    latitude: 30.0842004,
    longitude: -94.10179
  }
}, {
  name: 'Olympic Towers',
  address: {
    display: '300 Pearl Street Buffalo, NY 14202',
    number: '300',
    street: 'Pearl Street',
    city: 'Buffalo',
    state: 'NY',
    zipcode: '14202'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-western-bankruptcy-court-buffalo',
  phone: '716-362-3200',
  state: 'NY',
  district: 'nywb',
  coordinates: {
    latitude: 42.8875333,
    longitude: -78.87499
  }
}, {
  name: 'Kenneth B. Keating Federal Building',
  address: {
    display: '100 State Street Rochester, NY 14614',
    number: '100',
    street: 'State Street',
    city: 'Rochester',
    state: 'NY',
    zipcode: '14614'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-western-bankruptcy-court-rochester',
  phone: '585-613-4200',
  state: 'NY',
  district: 'nywb',
  coordinates: {
    latitude: 43.15743,
    longitude: -77.61411
  }
}, {
  name: 'E. Ross Adair Federal Building and United States Courthouse',
  address: {
    display: '1300 South Harrison Street Fort Wayne, IN 46802',
    number: '1300',
    street: 'South Harrison Street',
    city: 'Fort Wayne',
    state: 'IN',
    zipcode: '46802'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-northern-bankruptcy-court-fort-wayne',
  phone: '260-420-5100',
  state: 'IN',
  district: 'innb',
  coordinates: {
    latitude: 41.07374,
    longitude: -85.14002
  }
}, {
  name: 'Robert K. Rodibaugh United States Courthouse',
  address: {
    display: '401 South Michigan Street South Bend, IN 46601',
    number: '401',
    street: 'South Michigan Street',
    city: 'South Bend',
    state: 'IN',
    zipcode: '46601'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-northern-bankruptcy-court-south-bend',
  phone: '574-968-2100',
  state: 'IN',
  district: 'innb',
  coordinates: {
    latitude: 41.6717299,
    longitude: -86.2501599
  }
}, {
  name: 'Charles A. Halleck Federal Building',
  address: {
    display: '230 North Fourth Street Lafayette, IN 47901',
    number: '230',
    street: 'North Fourth Street',
    city: 'Lafayette',
    state: 'IN',
    zipcode: '47901'
  },
  url: 'http://www.uscourts.gov/court-locator/indiana-northern-bankruptcy-court-lafayette',
  phone: '765-420-6300',
  state: 'IN',
  district: 'innb',
  coordinates: {
    latitude: 40.41979,
    longitude: -86.89307
  }
}, {
  name: 'Robert W. Kastenmeier United States Courthouse',
  address: {
    display: '120 North Henry Street Madison, WI 53703',
    number: '120',
    street: 'North Henry Street',
    city: 'Madison',
    state: 'WI',
    zipcode: '53703'
  },
  url: 'http://www.uscourts.gov/court-locator/wisconsin-western-bankruptcy-court-madison',
  phone: '608-264-5178',
  state: 'WI',
  district: 'wiwb',
  coordinates: {
    latitude: 43.07376,
    longitude: -89.38867
  }
}, {
  name: 'James A. McClure Federal Building and United States Courthouse',
  address: {
    display: '550 West Fort Street Boise, ID 83724',
    number: '550',
    street: 'West Fort Street',
    city: 'Boise',
    state: 'ID',
    zipcode: '83724'
  },
  url: 'http://www.uscourts.gov/court-locator/idaho-bankruptcy-court-boise',
  phone: '208-334-1361',
  state: 'ID',
  district: 'idb',
  coordinates: {
    latitude: 43.62028,
    longitude: -116.19542
  }
}, {
  name: 'Robert S. Vance Federal Building',
  address: {
    display: '1800 Fifth Avenue North Birmingham, AL 35203',
    number: '1800',
    street: 'Fifth Avenue North',
    city: 'Birmingham',
    state: 'AL',
    zipcode: '35203'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-northern-bankruptcy-court-birmingham',
  phone: '205-714-4000',
  state: 'AL',
  district: 'alnb',
  coordinates: {
    latitude: 33.51708,
    longitude: -86.81029
  }
}, {
  name: 'Tuscaloosa Federal Courthouse',
  address: {
    display: '2005 University Boulevard Tuscaloosa, AL 35401',
    number: '2005',
    street: 'University Boulevard',
    city: 'Tuscaloosa',
    state: 'AL',
    zipcode: '35401'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-northern-bankruptcy-administrator-birmingham',
  phone: '205-714-3830',
  state: 'AL',
  district: 'alnb',
  coordinates: {
    latitude: 33.21117,
    longitude: -87.56363
  }
}, {
  name: 'United States Post Office Building',
  address: {
    display: '904 West Riverside Avenue Spokane, WA 99201',
    number: '904',
    street: 'West Riverside Avenue',
    city: 'Spokane',
    state: 'WA',
    zipcode: '99201'
  },
  url: 'http://www.uscourts.gov/court-locator/washington-eastern-bankruptcy-court-spokane',
  phone: '509-458-5300',
  state: 'WA',
  district: 'waeb',
  coordinates: {
    latitude: 47.65793,
    longitude: -117.42541
  }
}, {
  name: 'The Chinook Tower Building',
  address: {
    display: '402 East Yakima Avenue Yakima, WA 98901',
    number: '402',
    street: 'East Yakima Avenue',
    city: 'Yakima',
    state: 'WA',
    zipcode: '98901'
  },
  url: 'http://www.uscourts.gov/court-locator/washington-eastern-bankruptcy-court-yakima',
  phone: '509-576-6100',
  state: 'WA',
  district: 'waeb',
  coordinates: {
    latitude: 46.60337,
    longitude: -120.5011
  }
}, {
  name: 'United States Courthouse Annex',
  address: {
    display: '110 East Court Avenue Des Moines, IA 50309',
    number: '110',
    street: 'East Court Avenue',
    city: 'Des Moines',
    state: 'IA',
    zipcode: '50309'
  },
  url: 'http://www.uscourts.gov/court-locator/iowa-southern-bankruptcy-court-des-moines',
  phone: '515-284-6230',
  state: 'IA',
  district: 'iasb',
  coordinates: {
    latitude: 41.5863387,
    longitude: -93.6152563
  }
}, {
  name: 'One Arsenal Place',
  address: {
    display: '901 Front Avenue Columbus, GA 31901',
    number: '901',
    street: 'Front Avenue',
    city: 'Columbus',
    state: 'GA',
    zipcode: '31901'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-middle-bankruptcy-court-columbus',
  phone: '706-649-7837',
  state: 'GA',
  district: 'gamb',
  coordinates: {
    latitude: 32.4632999,
    longitude: -84.99475
  }
}, {
  name: '433 Cherry Street',
  address: {
    display: '433 Cherry Street Macon, GA 31201',
    number: '433',
    street: 'Cherry Street',
    city: 'Macon',
    state: 'GA',
    zipcode: '31201'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-middle-bankruptcy-court-macon',
  phone: '478-752-3506',
  state: 'GA',
  district: 'gamb',
  coordinates: {
    latitude: 32.83519,
    longitude: -83.62666
  }
}, {
  name: 'Frank M. Johnson, Jr. United States Courthouse',
  address: {
    display: 'One Church Street Montgomery, AL 36104',
    number: null,
    street: 'One Church Street',
    city: 'Montgomery',
    state: 'AL',
    zipcode: '36104'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-middle-bankruptcy-court-montgomery',
  phone: '334-954-3800',
  state: 'AL',
  district: 'almb',
  coordinates: {
    latitude: 32.37492,
    longitude: -86.31036
  }
}, {
  name: 'Tom Stagg United States Court House',
  address: {
    display: '300 Fannin Street Shreveport, LA 71101',
    number: '300',
    street: 'Fannin Street',
    city: 'Shreveport',
    state: 'LA',
    zipcode: '71101'
  },
  url: 'http://www.uscourts.gov/court-locator/louisiana-western-bankruptcy-court-shreveport',
  phone: '318-676-4267',
  state: 'LA',
  district: 'lawb',
  coordinates: {
    latitude: 32.5157996,
    longitude: -93.749544
  }
}, {
  name: 'Hemenway Building',
  address: {
    display: '300 Jackson Street Alexandria, LA 71301',
    number: '300',
    street: 'Jackson Street',
    city: 'Alexandria',
    state: 'LA',
    zipcode: '71301'
  },
  url: 'http://www.uscourts.gov/court-locator/louisiana-western-bankruptcy-court-alexandria',
  phone: '318-445-1890',
  state: 'LA',
  district: 'lawb',
  coordinates: {
    latitude: 31.31217,
    longitude: -92.44623
  }
}, {
  name: 'The Lemoine Company Building',
  address: {
    display: '214 Jefferson Street Lafayette, LA 70501',
    number: '214',
    street: 'Jefferson Street',
    city: 'Lafayette',
    state: 'LA',
    zipcode: '70501'
  },
  url: 'http://www.uscourts.gov/court-locator/louisiana-western-bankruptcy-court-lafayette',
  phone: '337-262-6800',
  state: 'LA',
  district: 'lawb',
  coordinates: {
    latitude: 30.2272,
    longitude: -92.01621
  }
}, {
  name: 'Old United States Post Office and Courthouse',
  address: {
    display: '300 West Second Street Little Rock, AR 72201',
    number: '300',
    street: 'West Second Street',
    city: 'Little Rock',
    state: 'AR',
    zipcode: '72201'
  },
  url: 'http://www.uscourts.gov/court-locator/arkansas-eastern-western-bankruptcy-court-little-rock',
  phone: '501-918-5500',
  state: 'AR',
  district: 'areb',
  coordinates: {
    latitude: 34.74751,
    longitude: -92.27348
  }
}, {
  name: 'John Paul Hammerschmidt Federal Building',
  address: {
    display: '35 East Mountain Street Fayetteville, AR 72701',
    number: '35',
    street: 'East Mountain Street',
    city: 'Fayetteville',
    state: 'AR',
    zipcode: '72701'
  },
  url: 'http://www.uscourts.gov/court-locator/arkansas-eastern-western-bankruptcy-court-fayetteville',
  phone: '479-582-9800',
  state: 'AR',
  district: 'arwb',
  coordinates: {
    latitude: 36.06191,
    longitude: -94.15848
  }
}, {
  name: 'Federal Justice Center - The Plaza Building',
  address: {
    display: '600 James Brown Boulevard Augusta, GA 30901',
    number: '600',
    street: 'James Brown Boulevard',
    city: 'Augusta',
    state: 'GA',
    zipcode: '30901'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-southern-bankruptcy-court-augusta',
  phone: '706-823-6000',
  state: 'GA',
  district: 'gasb',
  coordinates: {
    latitude: 33.4717039,
    longitude: -81.9696943
  }
}, {
  name: 'Tomochichi United States Courthouse',
  address: {
    display: '125 Bull Street Savannah, GA 31401',
    number: '125',
    street: 'Bull Street',
    city: 'Savannah',
    state: 'GA',
    zipcode: '31401'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-southern-bankruptcy-court-savannah',
  phone: '912-650-4100',
  state: 'GA',
  district: 'gasb',
  coordinates: {
    latitude: 32.0780699,
    longitude: -81.09268
  }
}, {
  name: 'Frank M. Scarlett Federal Building',
  address: {
    display: '801 Gloucester Street Brunswick, GA 31520',
    number: '801',
    street: 'Gloucester Street',
    city: 'Brunswick',
    state: 'GA',
    zipcode: '31520'
  },
  url: 'http://www.uscourts.gov/court-locator/georgia-southern-bankruptcy-court-brunswick',
  phone: '912-280-1376',
  state: 'GA',
  district: 'gasb',
  coordinates: {
    latitude: 31.14987,
    longitude: -81.4923699
  }
}, {
  name: 'John A. Campbell United States Courthouse',
  address: {
    display: '113 St. Joseph Street Mobile, AL 36602',
    number: '113',
    street: 'St. Joseph Street',
    city: 'Mobile',
    state: 'AL',
    zipcode: '36602'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-southern-bankruptcy-administrator-mobile',
  phone: '251-441-5433',
  state: 'AL',
  district: 'alsb',
  coordinates: {
    latitude: 30.6937538,
    longitude: -88.0425969
  }
}, {
  name: 'United State Bankruptcy Court',
  address: {
    display: '201 St. Louis Street Mobile, AL 36602',
    number: '201',
    street: 'St. Louis Street',
    city: 'Mobile',
    state: 'AL',
    zipcode: '36602'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-southern-bankruptcy-court-mobile',
  phone: '251-441-5391',
  state: 'AL',
  district: 'alsb',
  coordinates: {
    latitude: 30.69394,
    longitude: -88.04426
  }
}, {
  name: '1 Division Avenue, N.',
  address: {
    display: '1 Division Avenue, N. Grand Rapids, MI 49503',
    number: '1',
    street: 'Division Avenue, N.',
    city: 'Grand Rapids',
    state: 'MI',
    zipcode: '49503'
  },
  url: 'http://www.uscourts.gov/court-locator/michigan-western-bankruptcy-court-grand-rapids',
  phone: '616-456-2693',
  state: 'MI',
  district: 'miwb',
  coordinates: {
    latitude: 42.96362,
    longitude: -85.66795
  }
}, {
  name: 'Frank E. Moss United States Courthouse',
  address: {
    display: '350 South Main Street Salt Lake City, UT 84101',
    number: '350',
    street: 'South Main Street',
    city: 'Salt Lake City',
    state: 'UT',
    zipcode: '84101'
  },
  url: 'http://www.uscourts.gov/court-locator/utah-bankruptcy-court-salt-lake-city',
  phone: '801-524-6687',
  state: 'UT',
  district: 'utb',
  coordinates: {
    latitude: 40.76151,
    longitude: -111.8912
  }
}, {
  name: 'Winston E. Arnow Federal Building',
  address: {
    display: '100 North Palafox Street Pensacola, FL 32502',
    number: '100',
    street: 'North Palafox Street',
    city: 'Pensacola',
    state: 'FL',
    zipcode: '32502'
  },
  url: 'http://www.uscourts.gov/court-locator/florida-northern-bankruptcy-court-pensacola',
  phone: '866-639-4615',
  state: 'FL',
  district: 'flnb',
  coordinates: {
    latitude: 30.41461,
    longitude: -87.21562
  }
}, {
  name: 'Seybourn H. Lynne United States Courthouse',
  address: {
    display: '400 Well Street Decatur, AL 35601',
    number: '400',
    street: 'Well Street',
    city: 'Decatur',
    state: 'AL',
    zipcode: '35601'
  },
  url: 'http://www.uscourts.gov/court-locator/alabama-northern-bankruptcy-court-decatur',
  phone: '256-584-7900',
  state: 'AL',
  district: 'alnb',
  coordinates: {
    latitude: 34.6067604,
    longitude: -86.9823798
  }
}, {
  name: 'Howard H. Baker Jr. United States Courthouse',
  address: {
    display: '800 Market Street Knoxville, TN 37902',
    number: '800',
    street: 'Market Street',
    city: 'Knoxville',
    state: 'TN',
    zipcode: '37902'
  },
  url: 'http://www.uscourts.gov/court-locator/tennessee-eastern-bankruptcy-court-knoxville',
  phone: '865-545-4279',
  state: 'TN',
  district: 'tneb',
  coordinates: {
    latitude: 35.9617999,
    longitude: -83.91755
  }
}, {
  name: 'James H. Quillen United States Courthouse',
  address: {
    display: '220 West Depot Street Greeneville, TN 37743',
    number: '220',
    street: 'West Depot Street',
    city: 'Greeneville',
    state: 'TN',
    zipcode: '37743'
  },
  url: 'http://www.uscourts.gov/court-locator/tennessee-eastern-bankruptcy-court-greeneville',
  phone: '423-787-0113',
  state: 'TN',
  district: 'tneb',
  coordinates: {
    latitude: 36.16423,
    longitude: -82.83362
  }
}, {
  name: 'Historic United States Courthouse',
  address: {
    display: '31 East 11th Street Chattanooga, TN 37402',
    number: '31',
    street: 'East 11th Street',
    city: 'Chattanooga',
    state: 'TN',
    zipcode: '37402'
  },
  url: 'http://www.uscourts.gov/court-locator/tennessee-eastern-bankruptcy-court-chattanooga',
  phone: '423-752-5163',
  state: 'TN',
  district: 'tneb',
  coordinates: {
    latitude: 35.04352,
    longitude: -85.3082699
  }
}, {
  name: 'The Federal Center',
  address: {
    display: '380 Westminster Street Providence, RI 02903',
    number: '380',
    street: 'Westminster Street',
    city: 'Providence',
    state: 'RI',
    zipcode: '02903'
  },
  url: 'http://www.uscourts.gov/court-locator/rhode-island-bankruptcy-court-providence',
  phone: '401-626-3100',
  state: 'RI',
  district: 'rib',
  coordinates: {
    latitude: 41.82129,
    longitude: -71.41489
  }
}, {
  name: '501 East Court Street',
  address: {
    display: '501 East Court Street Jackson, MS 39201',
    number: '501',
    street: 'East Court Street',
    city: 'Jackson',
    state: 'MS',
    zipcode: '39201'
  },
  url: 'http://www.uscourts.gov/court-locator/mississippi-southern-bankruptcy-court-jackson',
  phone: '601-608-4600',
  state: 'MS',
  district: 'mssb',
  coordinates: {
    latitude: 32.29536,
    longitude: -90.184325
  }
}, {
  name: 'Dan M. Russell, Jr. United States Courthouse',
  address: {
    display: '2012 15th Street Gulfport, MS 39501',
    number: '2012',
    street: '15th Street',
    city: 'Gulfport',
    state: 'MS',
    zipcode: '39501'
  },
  url: 'http://www.uscourts.gov/court-locator/mississippi-southern-bankruptcy-court-gulfport',
  phone: '228-563-1790',
  state: 'MS',
  district: 'mssb',
  coordinates: {
    latitude: 30.36925,
    longitude: -89.08673
  }
}, {
  name: 'Brien McMahon Federal Building and United States Courthouse',
  address: {
    display: '915 Lafayette Boulevard Bridgeport, CT 06604',
    number: '915',
    street: 'Lafayette Boulevard',
    city: 'Bridgeport',
    state: 'CT',
    zipcode: '06604'
  },
  url: 'http://www.uscourts.gov/court-locator/connecticut-bankruptcy-court-bridgeport',
  phone: '203-579-5808',
  state: 'CT',
  district: 'ctb',
  coordinates: {
    latitude: 41.17526,
    longitude: -73.19234
  }
}, {
  name: 'Connecticut Financial Center',
  address: {
    display: '157 Church Street New Haven, CT 06510',
    number: '157',
    street: 'Church Street',
    city: 'New Haven',
    state: 'CT',
    zipcode: '06510'
  },
  url: 'http://www.uscourts.gov/court-locator/connecticut-bankruptcy-court-new-haven',
  phone: '203-773-2009',
  state: 'CT',
  district: 'ctb',
  coordinates: {
    latitude: 41.30717,
    longitude: -72.92496
  }
}, {
  name: 'Abraham Ribicoff Federal Building and United States Courthouse',
  address: {
    display: '450 Main Street Hartford, CT 06103',
    number: '450',
    street: 'Main Street',
    city: 'Hartford',
    state: 'CT',
    zipcode: '06103'
  },
  url: 'http://www.uscourts.gov/court-locator/connecticut-bankruptcy-court-hartford',
  phone: '860-240-3675',
  state: 'CT',
  district: 'ctb',
  coordinates: {
    latitude: 41.76141,
    longitude: -72.67474
  }
}, {
  name: 'James M. Hanley Federal Building',
  address: {
    display: '100 South Clinton Street Syracuse, NY 13261',
    number: '100',
    street: 'South Clinton Street',
    city: 'Syracuse',
    state: 'NY',
    zipcode: '13261'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-northern-bankruptcy-court-syracuse',
  phone: '315-295-1600',
  state: 'NY',
  district: 'nynb',
  coordinates: {
    latitude: 43.05012,
    longitude: -76.15353
  }
}, {
  name: 'Alexander Pirnie Federal Building',
  address: {
    display: '10 Broad Street Utica, NY 13501',
    number: '10',
    street: 'Broad Street',
    city: 'Utica',
    state: 'NY',
    zipcode: '13501'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-northern-bankruptcy-court-utica',
  phone: '315-793-8101',
  state: 'NY',
  district: 'nynb',
  coordinates: {
    latitude: 43.10357,
    longitude: -75.2255799
  }
}, {
  name: 'James T. Foley United States Courthouse',
  address: {
    display: '445 Broadway Albany, NY 12207',
    number: '445',
    street: 'Broadway',
    city: 'Albany',
    state: 'NY',
    zipcode: '12207'
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-northern-bankruptcy-court-albany',
  phone: '518-257-1661',
  state: 'NY',
  district: 'nynb',
  coordinates: {
    latitude: 42.64962,
    longitude: -73.75063
  }
}, {
  name: 'J. Bratton Davis United States Courthouse',
  address: {
    display: '1100 Laurel Street Columbia, SC 29201',
    number: '1100',
    street: 'Laurel Street',
    city: 'Columbia',
    state: 'SC',
    zipcode: '29201'
  },
  url: 'http://www.uscourts.gov/court-locator/south-carolina-bankruptcy-court-columbia',
  phone: '803-765-5436',
  state: 'SC',
  district: 'scb',
  coordinates: {
    latitude: 34.00896,
    longitude: -81.03813
  }
}, {
  name: 'Donald S. Russell Federal Courthouse',
  address: {
    display: '201 Magnolia Street Spartanburg, SC 29306',
    number: '201',
    street: 'Magnolia Street',
    city: 'Spartanburg',
    state: 'SC',
    zipcode: '29306'
  },
  url: 'http://www.uscourts.gov/court-locator/south-carolina-bankruptcy-court-spartanburg',
  phone: '864-591-5315',
  state: 'SC',
  district: 'scb',
  coordinates: {
    latitude: 34.95169,
    longitude: -81.93454
  }
}, {
  name: 'King and Queen Street Building',
  address: {
    display: '145 King Street Charleston, SC 29401',
    number: '145',
    street: 'King Street',
    city: 'Charleston',
    state: 'SC',
    zipcode: '29401'
  },
  url: 'http://www.uscourts.gov/court-locator/south-carolina-bankruptcy-court-charleston',
  phone: '843-727-4112',
  state: 'SC',
  district: 'scb',
  coordinates: {
    latitude: 32.77742,
    longitude: -79.93286
  }
}, {
  name: 'United States Courthouse',
  address: {
    display: '400 South Phillips Avenue Sioux Falls, SD 57104',
    number: '400',
    street: 'South Phillips Avenue',
    city: 'Sioux Falls',
    state: 'SD',
    zipcode: '57104'
  },
  url: 'http://www.uscourts.gov/court-locator/south-dakota-bankruptcy-court-sioux-falls',
  phone: '605-357-2400',
  state: 'SD',
  district: 'sdb',
  coordinates: {
    latitude: 43.5431913,
    longitude: -96.7282575
  }
}, {
  name: 'United States Post Office and Courthouse',
  address: {
    display: '225 South Pierre Street Pierre, SD 57501',
    number: '225',
    street: 'South Pierre Street',
    city: 'Pierre',
    state: 'SD',
    zipcode: '57501'
  },
  url: 'http://www.uscourts.gov/court-locator/south-dakota-bankruptcy-court-pierre',
  phone: '605-945-4460',
  state: 'SD',
  district: 'sdb',
  coordinates: {
    latitude: 44.3673329,
    longitude: -100.3561009
  }
}, {
  name: 'Paul Findley Federal Building and United States Courthouse',
  address: {
    display: '600 East Monroe Street Springfield, IL 62701',
    number: '600',
    street: 'East Monroe Street',
    city: 'Springfield',
    state: 'IL',
    zipcode: '62701'
  },
  url: 'http://www.uscourts.gov/court-locator/illinois-central-bankruptcy-court-springfield',
  phone: '217-492-4551',
  state: 'IL',
  district: 'ilcb',
  coordinates: {
    latitude: 39.7994,
    longitude: -89.64721
  }
}, {
  name: 'Quentin N. Burdick United States Courthouse',
  address: {
    display: '655 First Avenue North Fargo, ND 58102',
    number: '655',
    street: 'First Avenue North',
    city: 'Fargo',
    state: 'ND',
    zipcode: '58102'
  },
  url: 'http://www.uscourts.gov/court-locator/north-dakota-bankruptcy-court-fargo',
  phone: '701-297-7100',
  state: 'ND',
  district: 'ndb',
  coordinates: {
    latitude: 46.87701,
    longitude: -96.79061
  }
}, {
  name: '1000 Elm Street',
  address: {
    display: '1000 Elm Street Manchester, NH 03101',
    number: '1000',
    street: 'Elm Street',
    city: 'Manchester',
    state: 'NH',
    zipcode: '03101'
  },
  url: 'http://www.uscourts.gov/court-locator/new-hampshire-bankruptcy-court-manchester',
  phone: '603-222-2600',
  state: 'NH',
  district: 'nhb',
  coordinates: {
    latitude: 42.99275,
    longitude: -71.46311
  }
}, {
  name: 'Warren B. Rudman United States Courthouse',
  address: {
    display: '55 Pleasant Street Concord, NH 03301',
    number: '55',
    street: 'Pleasant Street',
    city: 'Concord',
    state: 'NH',
    zipcode: '03301'
  },
  url: 'http://www.uscourts.gov/court-locator/new-hampshire-bankruptcy-court',
  phone: '603-222-2600',
  state: 'NH',
  district: 'nhb',
  coordinates: {
    latitude: 43.20261,
    longitude: -71.53947
  }
}, {
  name: 'Mike Mansfield Federal Building and United States Courthouse',
  address: {
    display: '400 North Main Street Butte, MT 59701',
    number: '400',
    street: 'North Main Street',
    city: 'Butte',
    state: 'MT',
    zipcode: '59701'
  },
  url: 'http://www.uscourts.gov/court-locator/montana-bankruptcy-court-butte',
  phone: '406-782-3354',
  state: 'MT',
  district: 'mtb',
  coordinates: {
    latitude: 46.0162302,
    longitude: -112.53606
  }
}, {
  name: 'Russell E. Smith Federal Building',
  address: {
    display: '201 East Broadway Street Missoula, MT 59802',
    number: '201',
    street: 'East Broadway Street',
    city: 'Missoula',
    state: 'MT',
    zipcode: '59802'
  },
  url: 'http://www.uscourts.gov/court-locator/montana-bankruptcy-court',
  phone: '406-542-7260',
  state: 'MT',
  district: 'mtb',
  coordinates: {
    latitude: 46.87146,
    longitude: -113.99187
  }
}, {
  name: 'Commonwealth of Virginia Building',
  address: {
    display: '210 Church Avenue Roanoke, VA 24011',
    number: '210',
    street: 'Church Avenue',
    city: 'Roanoke',
    state: 'VA',
    zipcode: '24011'
  },
  url: 'http://www.uscourts.gov/court-locator/virginia-western-bankruptcy-court-roanoke',
  phone: '540-857-2391',
  state: 'VA',
  district: 'vawb',
  coordinates: {
    latitude: 37.2707768,
    longitude: -79.9444755
  }
}, {
  name: 'Max Rosenn United States Courthouse',
  address: {
    display: '197 South Main Street Wilkes Barre, PA 18701',
    number: '197',
    street: 'South Main Street',
    city: 'Wilkes Barre',
    state: 'PA',
    zipcode: '18701'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-middle-bankruptcy-court-wilkes-barre',
  phone: '570-831-2500',
  state: 'PA',
  district: 'pamb',
  coordinates: {
    latitude: 41.24234,
    longitude: -75.88827
  }
}, {
  name: 'Ronald Reagan Federal Building',
  address: {
    display: '228 Walnut Street Harrisburg, PA 17108',
    number: '228',
    street: 'Walnut Street',
    city: 'Harrisburg',
    state: 'PA',
    zipcode: '17108'
  },
  url: 'http://www.uscourts.gov/court-locator/pennsylvania-middle-bankruptcy-court-harrisburg',
  phone: '717-901-2800',
  state: 'PA',
  district: 'pamb',
  coordinates: {
    latitude: 40.26138,
    longitude: -76.88247
  }
}, {
  name: '824 North Market Street',
  address: {
    display: '824 North Market Street Wilmington, DE 19801',
    number: '824',
    street: 'North Market Street',
    city: 'Wilmington',
    state: 'DE',
    zipcode: '19801'
  },
  url: 'http://www.uscourts.gov/court-locator/delaware-bankruptcy-court-wilmington',
  phone: '302-252-2900',
  state: 'DE',
  district: 'deb',
  coordinates: {
    latitude: 39.74423,
    longitude: -75.5486899
  }
}, {
  name: 'J.B. Brown Block',
  address: {
    display: '537 Congress Street Portland, ME 04101',
    number: '537',
    street: 'Congress Street',
    city: 'Portland',
    state: 'ME',
    zipcode: '04101'
  },
  url: 'http://www.uscourts.gov/court-locator/maine-bankruptcy-court-portland',
  phone: '207-780-3482',
  state: 'ME',
  district: 'meb',
  coordinates: {
    latitude: 43.6556799,
    longitude: -70.26142
  }
}, {
  name: 'Margaret Chase Smith Federal Building',
  address: {
    display: '202 Harlow Street Bangor, ME 04401',
    number: '202',
    street: 'Harlow Street',
    city: 'Bangor',
    state: 'ME',
    zipcode: '04401'
  },
  url: 'http://www.uscourts.gov/court-locator/maine-bankruptcy-court-bangor',
  phone: '207-945-0348',
  state: 'ME',
  district: 'meb',
  coordinates: {
    latitude: 44.80498,
    longitude: -68.77343
  }
}, {
  name: "Joseph C. O'Mahoney Federal Building",
  address: {
    display: '2120 Capitol Avenue Cheyenne, WY 82001',
    number: '2120',
    street: 'Capitol Avenue',
    city: 'Cheyenne',
    state: 'WY',
    zipcode: '82001'
  },
  url: 'http://www.uscourts.gov/court-locator/wyoming-bankruptcy-court-cheyenne',
  phone: '307-433-2200',
  state: 'WY',
  district: 'wyb',
  coordinates: {
    latitude: 41.13753,
    longitude: -104.8184799
  }
}, {
  name: 'Ewing T. Kerr Federal Building and United States Courthouse',
  address: {
    display: '111 South Wolcott Street Casper, WY 82601',
    number: '111',
    street: 'South Wolcott Street',
    city: 'Casper',
    state: 'WY',
    zipcode: '82601'
  },
  url: 'http://www.uscourts.gov/court-locator/wyoming-bankruptcy-court-casper',
  phone: '307-232-2650',
  state: 'WY',
  district: 'wyb',
  coordinates: {
    latitude: 42.84968,
    longitude: -106.3237599
  }
}, {
  name: 'Thad Cochran United States Bankruptcy Courthouse',
  address: {
    display: '703 Hwy 145 North Aberdeen, MS 39730',
    number: '703',
    street: 'Hwy 145 North',
    city: 'Aberdeen',
    state: 'MS',
    zipcode: '39730'
  },
  url: 'http://www.uscourts.gov/court-locator/mississippi-northern-bankruptcy-court-aberdeen',
  phone: '662-369-2596',
  state: 'MS',
  district: 'msnb',
  coordinates: {
    latitude: 33.84968,
    longitude: -88.58354
  }
}, {
  name: 'Robert C. Byrd United States Courthouse',
  address: {
    display: '300 Virginia Street East Charleston, WV 25301',
    number: '300',
    street: 'Virginia Street East',
    city: 'Charleston',
    state: 'WV',
    zipcode: '25301'
  },
  url: 'http://www.uscourts.gov/court-locator/west-virginia-southern-bankruptcy-court-charleston',
  phone: '304-347-3003',
  state: 'WV',
  district: 'wvsb',
  coordinates: {
    latitude: 38.35212,
    longitude: -81.63947
  }
}, {
  name: 'Sidney L. Christie Federal Building',
  address: {
    display: '845 Fifth Avenue Huntington, WV 25701',
    number: '845',
    street: 'Fifth Avenue',
    city: 'Huntington',
    state: 'WV',
    zipcode: '25701'
  },
  url: 'http://www.uscourts.gov/court-locator/west-virginia-southern-bankruptcy-court-huntington',
  phone: '304-525-0375',
  state: 'WV',
  district: 'wvsb',
  coordinates: {
    latitude: 38.41918,
    longitude: -82.44503
  }
}, {
  name: 'Robert C. Byrd United States Courthouse and IRS Complex',
  address: {
    display: '110 North Heber Street Beckley, WV 25801',
    number: '110',
    street: 'North Heber Street',
    city: 'Beckley',
    state: 'WV',
    zipcode: '25801'
  },
  url: 'http://www.uscourts.gov/court-locator/west-virginia-southern-bankruptcy-court-beckley',
  phone: '304-253-7402',
  state: 'WV',
  district: 'wvsb',
  coordinates: {
    latitude: 37.77725,
    longitude: -81.18984
  }
}, {
  name: 'Melvin Price Federal Building and United States Courthouse',
  address: {
    display: '750 Missouri Avenue East St. Louis, IL 62201',
    number: '750',
    street: 'Missouri Avenue',
    city: 'East St. Louis',
    state: 'IL',
    zipcode: '62201'
  },
  url: 'http://www.uscourts.gov/court-locator/illinois-southern-bankruptcy-court-east-st-louis',
  phone: '618-482-9400',
  state: 'IL',
  district: 'ilsb',
  coordinates: {
    latitude: 38.623905,
    longitude: -90.156269
  }
}, {
  name: 'Federal Building',
  address: {
    display: '11 Elmwood Avenue Burlington, VT 05401',
    number: '11',
    street: 'Elmwood Avenue',
    city: 'Burlington',
    state: 'VT',
    zipcode: '05401'
  },
  url: 'http://www.uscourts.gov/court-locator/vermont-bankruptcy-court',
  phone: '844-644-7459',
  state: 'VT',
  district: 'vtb',
  coordinates: {
    latitude: 44.480716,
    longitude: -73.2163
  }
}];
exports["default"] = _default;